import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationMessages } from "../../../localization/messages.js";
import { MenuActionCreators } from "../../../redux/action-creators/index.js";
import settingsActionCreators from "../../../redux/action-creators/settingsActionCreators.js";
import userContextSelectors from "../../../redux/selectors/userContextSelectors.js";
import { HeaderCloseIconPosition } from "../../common/Drawer/Header/constants.js";
import DrawerHeader from "../../common/Drawer/Header/DrawerHeader.js";
import { TrackingUtils } from "../../../utils/index.js";
import { Rotation } from "../../../constants/index.js";

const SettingsDrawerHeader = () => {
  const isMobile = useSelector(userContextSelectors.isMobile);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const onDrawerClose = useCallback(() => {
    TrackingUtils.sendAnalytics({
      dataCategory: "Settings Area",
      dataAction: "click",
      dataLabel: `uc-settings-${isMobile ? "mobile" : "pc"}-close`
    });

    dispatch(settingsActionCreators.general.toggleDrawer());

    if (isMobile) dispatch(MenuActionCreators.showHamburgerMenu());
  }, [isMobile, dispatch]);

  return (
    <DrawerHeader
      text={formatMessage(LocalizationMessages.Settings)}
      closeIconName={isMobile ? "cool_arrow" : "close"}
      closeIconPosition={
        isMobile ? HeaderCloseIconPosition.Left : HeaderCloseIconPosition.Right
      }
      closeIconRotation={isMobile ? Rotation["180deg"] : Rotation.Default}
      closeDataTestId="uc-settings-area-header-close"
      onCloseClick={onDrawerClose}
    />
  );
};

export default React.memo(SettingsDrawerHeader);
